import React from "react";
import styled from "styled-components";

import Element from "./element";
import { ItemTypes } from "../constants/elements";
import { Divider, HCenter, VCenter } from "../reusable/layout";

import "./catalog.css";

const Catalog = styled.ul`
  display: flex;
  flex-direction: column;
  ${HCenter};
  ${VCenter};
`;

export default () => {
  return (
    <Catalog>
      <Element elementType={ItemTypes.ELEMENT_EMPTYCONTAINER} />
      <Divider h="20px" />
      <Element elementType={ItemTypes.ELEMENT_TEXT} />
      <Divider h="20px" />
      <Element elementType={ItemTypes.ELEMENT_IMAGE} />
      {/* <Divider h="20px" />
      <Element elementType={ItemTypes.ELEMENT_ICON} />
      <Divider h="20px" />
      <Element elementType={ItemTypes.ELEMENT_VIDEO} />
      <Divider h="20px" />
      <Element elementType={ItemTypes.ELEMENT_SLIDER} />
      <Divider h="20px" />
      <Element elementType={ItemTypes.ELEMENT_PROGRESSBAR} /> */}
      {/* <Divider h="20px" /> */}
      {/* <Element
        elementType={ItemTypes.ELEMENT_EMPTYCONTAINER}
        elementStarter={ItemTypes.ELEMENT_COUNTDOWN}
      /> */}
    </Catalog>
  );
};



// WEBPACK FOOTER //
// ./src/catalog/index.js